/**
 * @generated SignedSource<<54076a84bed0468a447db93314f38f25>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSpaPageContainer$data = {
  readonly jira: {
    readonly __typename: "JiraQuery";
    readonly " $fragmentSpreads": FragmentRefs<"BannerContent">;
  } | null | undefined;
  readonly " $fragmentType": "JiraSpaPageContainer";
};
export type JiraSpaPageContainer$key = {
  readonly " $data"?: JiraSpaPageContainer$data;
  readonly " $fragmentSpreads": FragmentRefs<"JiraSpaPageContainer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "JiraSpaPageContainer",
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "BannerContent"
        },
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "7545642d8f78caac5cf3e05e6ddee22d";

export default node;
